// Firm Roles
const ROLE_COMPLIANCE = 'Compliance'
const ROLE_NORMAL = 'Normal'

export const FIRM_ROLE = {
  ROLE_COMPLIANCE,
  ROLE_NORMAL,
}

// Group Roles
export const ROLE_CAPTAIN = 'Captain'
export const ROLE_MANAGER = 'Manager'
export const ROLE_CONTRIBUTOR = 'Contributor'

export const GROUP_ROLE = {
  ROLE_CAPTAIN,
  ROLE_MANAGER,
  ROLE_CONTRIBUTOR,
}

// Internal Roles
export const ROLE_MASTER = 'Master'
export const ROLE_ADMIN = 'Admin'
export const ROLE_VIEWONLY = 'SuperViewer'

export const INTERNAL_ROLE = {
  ROLE_MASTER,
  ROLE_ADMIN,
  ROLE_NORMAL,
  ROLE_VIEWONLY,
}
